import { FC, useState } from 'react'
import { Checkbox, ListItemText, Select, MenuItem, OutlinedInput, SelectProps, Typography } from '@mui/material'

/* Components */
import { InstanceCheckedIcon, InstanceUncheckedIcon, SelectDropdownIcon } from 'ui/components/svg'
import theme from 'theme'
import { CategoryMenuProps, IntegrationsFormControl, Wrapper } from './integrationsSelectField.styles'

interface Props extends SelectProps {
  options: string[]
  value: any
  handleChange: any
  label?: string
  shouldCapitalize?: boolean
}

const IntegrationsSelectField: FC<Props> = ({
  options,
  handleChange,
  placeholder,
  value,
  shouldCapitalize,
  label,
  ...rest
}) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  return (
    <Wrapper className="dropdown-container">
      {label && <Typography className="label-text">{label}</Typography>}
      <IntegrationsFormControl
        isselected={
          placeholder === 'configuration status'
            ? value.length > 0
              ? 'true'
              : 'false'
            : value.length > 0
            ? 'true'
            : 'false'
        }
        isopen={anchorEl ? 'true' : 'false'}
      >
        <Select
          labelId="integrations-select-label"
          id="integrations-select"
          displayEmpty
          MenuProps={{
            ...CategoryMenuProps,
            PaperProps: {
              ...CategoryMenuProps.PaperProps,
              sx: {
                ...CategoryMenuProps.PaperProps.sx,
                display: anchorEl ? 'block' : 'none'
              }
            },
            anchorEl,
            open: Boolean(anchorEl),
            onClose: () => setAnchorEl(null)
          }}
          sx={{
            '& .MuiSelect-icon': { transform: anchorEl ? 'rotate(180deg)' : 'rotate(0deg)' },
            textTransform: shouldCapitalize ? 'capitalize' : ''
          }}
          IconComponent={(props) => (
            <SelectDropdownIcon {...props} className={`${props.className} ${anchorEl ? 'is-open' : ''}`} />
          )}
          renderValue={(selected) => {
            if (Array.isArray(selected)) {
              const pruned = selected.filter((s: string) => s !== '')
              if (pruned.length === 0) {
                return 'None'
              }
              if (pruned.length === 1) {
                return pruned[0]
              }

              return `${pruned.length} selected`
            }

            return selected
          }}
          inputProps={{ 'aria-label': 'Without label' }}
          {...rest}
          value={value}
          onChange={handleChange}
          input={<OutlinedInput onMouseDown={handleClick} />}
        >
          {options.map((option) => (
            <MenuItem
              key={option}
              value={option}
              onClick={() => {
                if (!rest.multiple) {
                  setAnchorEl(null)
                }
              }}
            >
              {rest.multiple && (
                <Checkbox
                  checked={value.indexOf(option) > -1}
                  icon={<InstanceUncheckedIcon />}
                  checkedIcon={<InstanceCheckedIcon />}
                />
              )}
              <ListItemText
                primary={option}
                sx={{
                  '.MuiTypography-root': {
                    color: value.indexOf(option) > -1 ? `${theme.colors.menuItemText} !important` : '',
                    textTransform: shouldCapitalize ? 'capitalize' : ''
                  }
                }}
              />
            </MenuItem>
          ))}
        </Select>
      </IntegrationsFormControl>
    </Wrapper>
  )
}

export default IntegrationsSelectField
